<template>
    <section class="members-section" ref="membersSection" :style="{'scroll-margin-top':headerHeight}">
        <div class="download-wrapper">
            <div class="field-box">
                <label class="field-label">Search</label>
                <select class="search-by" v-model="searchBy">
                    <option v-for="variant in searchVariants" :key="variant.value" :value="variant.value">
                        {{ variant.title }}
                    </option>
                </select>
                <div class="search-value">
                    <input type="text" style="width: 100%;" v-model="searchValue" />
                </div>
                <div class="buttons">
                    <button :disabled="isLoading" type="button" @click="search">Search</button>
                    <button :disabled="isLoading" type="button" @click="clear">Clear</button>
                </div>
            </div>

            <div class="button-wrapper">
                <button :disabled="isLoading" type="button" v-if="accessPdf" @click="downloadPdf">Download as PDF</button>
            </div>
        </div>

        <div class="table-wrapper">
            <table class="members-table">
                <thead>
                <tr>
                    <th
                        v-for="(title, i) in titles"
                        :key="i" :style="'min-width: ' + columnWidth(title.key) + '; width: ' + columnWidth(title.key)"
                    >{{ title.title }} <span v-if="title.key === 'name'" class="sort-icon" @click="sortMembers"><img :src="sort === 'asc' ? '/images/sort_up.gif' : '/images/sort_down.gif'" /></span></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in members" :key="item.id">
                    <td v-for="(title, i) in titles" :key="i" style="vertical-align: top;">
                        <template v-if="title.key === 'name'">
                            <span v-html="item['name']"></span>
                        </template>

                        <template v-if="title.key === 'contact_information'">
                            <template v-if="item['address'] && item['address'] !== ''">
                                <span v-html="item['address']"></span><br />
                            </template>
                            <template v-if="item['phone'] && item['phone'] !== ''">
                                <a :href="'tel:' + item['phone']" target="_blank" rel="nofollow">{{ item['phone'] }}</a><br />
                            </template>
                            <template v-if="item['email'] && item['email'] !== ''">
                                <a :href="'mailto:' + item['email']" rel="nofollow">{{ item['email'] }}</a><br />
                            </template>
                            <template v-if="item['website'] && item['website'] !== ''">
                                <a :href="item['website']" target="_blank" rel="nofollow">{{ item['website'] }}</a>
                            </template>
                        </template>

                        <template v-if="title.key === 'photo'">
                            <img v-if="item['photo'] && item['photo'] !== ''" :src="item['photo']" width="120" />
                        </template>
                    </td>
                </tr>
                <tr  v-if="members.length === 0">
                    <td :colspan="titles.length">
                        <p style="text-align: center; font-size: 1.2em; font-weight: bold; padding: 16px 0 0 0;">No Records Found</p>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="paginate-wrapper">
            <pagination v-model="page" :records="count" :per-page="perPage" @paginate="loadData" :options="{
                chunksNavigation: 'scroll',
                edgeNavigation: true
            }"/>
        </div>
    </section>
</template>

<script>
import Pagination from 'vue-pagination-2';
import { headerOffset } from "../mixins/headerOffset";

export default {
    name: "MemberComponent",
    mixins: [
        headerOffset,
    ],
    components: {
        Pagination
    },
    data() {
        return {
            isLoading: false,
            titles: [],
            members: [],
            page: 1,
            count: 0,
            perPage: 50,
            accessPdf: false,
            sort: 'asc',
            searchBy: 'last_name',
            searchValue: '',
            searchVariants: [
                { value: 'last_name', title: 'Last / Org. Name' },
                { value: 'first_name', title: 'First / Preferred Name' }
            ]
        }
    },
    computed: {
        isAuth() {
            return window.safeData.isAuth && window.safeData.isAuth === '1';
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.isLoading = true;

            const members = this.members;

            this.$api.get('api/v1/members?page=' + this.page + '&sort=' + this.sort + '&search_by=' + this.searchBy + '&search_value=' + this.searchValue).then(response => {
                if (response.data) {
                    this.titles = response.data.titles;
                    this.perPage = response.data.data.per_page;
                    this.page = response.data.data.current_page;
                    this.count = response.data.data.total;
                    this.members = response.data.data.items;
                    this.accessPdf = response.data.data.access_pdf;
                }
            }).finally(() => {
                //>
                if (members.length > 0) {
                    this.$refs.membersSection.scrollIntoView({ behavior: 'smooth' });
                }

                this.isLoading = false;
            });
        },
        downloadPdf() {
            this.isLoading = true;
            this.$api.post('api/v1/members/download-pdf', {
                sort: this.sort,
                search_by: this.searchBy,
                search_value: this.searchValue
            }, {
                responseType: 'blob'
            }).then(response => {
                if (response.data) {
                    const link = document.createElement('a');
                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    link.href = window.URL.createObjectURL(blob);
                    window.open(link.href);
                    link.download = 'members.pdf';
                    document.body.appendChild(link);
                    // link.click();

                    document.body.removeChild(link);
                }
            }).finally(() => {
                this.isLoading = false;
            });
        },
        columnWidth(key) {
            const width = {
                name: '450px',
                contact_information: '350px',
                photo: '120px',
            };

            return width[key] || 'auto';
        },
        sortMembers() {
            this.sort = this.sort === 'asc' ? 'desc' : 'asc';
            this.loadData();
        },
        search() {
            this.loadData();
        },
        clear() {
            this.searchBy = 'last_name';
            this.searchValue = '';

            this.loadData();
        }
    }
}
</script>

<style lang="scss">
.VuePagination__pagination li {
    list-style: none!important;
}

.paginate-wrapper {
    .page-link {
        cursor: pointer;
    }
}
</style>

<style scoped lang="scss">
.table-wrapper {
    overflow-x: auto;
    padding: 16px 0;
}

.members-table {
    width: 100%;
    border-collapse: collapse;
    overflow-x: auto;

    thead {
        font-size: 0.8em;
        font-weight: bold;

        th {
            box-sizing: border-box;
            padding: 0 15px;
            border-bottom: 1px solid #ccc!important;
        }
    }

    td {
        font-size: 0.8em;
        box-sizing: border-box;
        padding: 5px 15px;
        word-break: break-all;
        border-bottom: 1px solid #ccc!important;
    }
}

.paginate-wrapper {
    float: right;
    text-align: right;
    padding: 16px 0 0 0;

    ul li {
        list-style: none!important;
    }
}

.download-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 32px 0;

    @media (max-width: 768px) {
        flex-direction: column;
        width: 100%;
    }

    button {
        background: #ffffff;
        min-width: 100px;
        border: 1px solid #000000;
        border-radius: 4px;
        height: 34px!important;
        padding: 0 15px;
    }

    button:hover {
        background: #f0f0f0;
    }
}

.button-wrapper {
    @media (max-width: 768px) {
        width: 100%;
        padding: 16px 0 0 0;
    }
}

.sort-icon {
    padding: 0 5px;
    display: inline-block;
    cursor: pointer;
}

.field-box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    @media (max-width: 992px) {
        flex-direction: column;
        width: 350px;
        align-items: initial;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        width: 100%;
        align-items: initial;
    }

    input, select {
        height: 34px!important;
    }

    .field-label {
        padding-right: 6px;
    }

    .search-by {
        margin-right: 6px;
        max-width: 200px;

        @media (max-width: 992px) {
            width: 100%;
            max-width: initial;
            margin: 0 0 6px 0;
        }
    }

    .search-value {
        margin-right: 6px;

        @media (max-width: 992px) {
            width: 100%;
            max-width: initial;
            margin: 0 0 6px 0;
        }
    }

    .buttons {

    }
}
</style>
